import { CardWithC4CssProps } from './CssConfig';

export const contactsConfigs = [
  {
    componentReference: 'title',
    label: 'Candidates',
    id: 'contacts-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
  },
  // cards
  {
    componentReference: 'container',
    id: 'pipelines-cards-container',
    children: [
      {
        containerType: 'contacts',
        componentType: 'card',
        componentReference: 'card',
        id: 'contacts_new',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'applied',
          id: 'applied',
          value: 8827,
          topLabel: 'New candidates',
          bottomLabel: 'CANDIDATES',
        },
        api: {
          subject_type: 'contacts',
          metadata: {
            tileKey: 'contacts_new',
            id: 'contacts_new',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'contacts_created',
          },
        },
      },
      {
        containerType: 'contacts',
        componentType: 'card',
        componentReference: 'card',
        id: 'contacts_sourced',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'contacts_sourced',
          value: 16,
          topLabel: 'Sourced',
          bottomLabel: 'CANDIDATES',
        },
        api: {
          subject_type: 'contacts',
          metadata: {
            tileKey: 'contacts_sourced',
            id: 'contacts_sourced',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'sourced',
          },
        },
      },
      {
        containerType: 'contacts',
        componentType: 'card',
        componentReference: 'card',
        id: 'contacts_inbound',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'applied',
          id: 'applied',
          value: 226,
          topLabel: 'Inbound',
          bottomLabel: 'CANDIDATES',
        },
        api: {
          subject_type: 'contacts',
          metadata: {
            id: 'contacts_inbound',
            tileKey: 'contacts_inbound',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'inbound',
          },
        },
      },
      {
        containerType: 'contacts',
        componentType: 'card',
        componentReference: 'card',
        id: 'contacts_referral',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: 36,
          topLabel: 'Referral',
          bottomLabel: 'CANDIDATES',
        },
        api: {
          subject_type: 'contacts',
          metadata: {
            tileKey: 'contacts_referral',
            id: 'contacts_referral',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'referral',
          },
        },
      },
    ],
  },

  //trend chart
  {
    containerType: 'contacts',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'contacts_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'New candidate trend by source (on candidate)',
      id: 'contacts_chart',
      chartData: {
        categories: ['2023-Q4', '2024-Q1', '2024-Q2', '2024-Q3', '2024-Q4'],
        series: [
          {
            data: [68, 637, 2646, 4270, 843],
            name: 'No source',
          },
          {
            data: [1, 0, 1, 1, 3],
            name: 'Indeed',
          },
          {
            data: [1, 0, 1, 1, 3],
            name: 'Job Target Via Job Target Programmatic',
          },
          {
            data: [0, 0, 2, 1, 16],
            name: 'Purnanak',
          },
          {
            data: [0, 0, 0, 18, 1],
            name: 'Internal',
          },
          {
            data: [0, 0, 0, 2, 162],
            name: 'Aarsh Dayal',
          },
          {
            data: [0, 0, 0, 3, 1],
            name: 'Linkedin',
          },
          {
            data: [0, 0, 0, 56, 0],
            name: 'Employee Referral',
          },
          {
            data: [0, 0, 0, 3, 0],
            name: 'Kula Flows',
          },
          {
            data: [0, 0, 0, 1, 0],
            name: 'Naven',
          },
          {
            data: [0, 0, 0, 39, 0],
            name: 'Website',
          },
          {
            data: [0, 0, 0, 46, 0],
            name: 'Kula Career Portal',
          },
          {
            data: [0, 0, 0, 7, 0],
            name: 'Peepal',
          },
          {
            data: [0, 0, 0, 2, 0],
            name: 'Divyanshu',
          },
          {
            data: [0, 0, 0, 1, 0],
            name: 'MNR',
          },
          {
            data: [0, 0, 0, 0, 0],
            name: 'Cygnus',
          },
          {
            data: [0, 0, 0, 0, 0],
            name: 'Naukri',
          },
          {
            data: [0, 0, 0, 0, 0],
            name: 'Ankit Nandwani',
          },
          {
            data: [0, 0, 0, 0, 0],
            name: 'Sarthak',
          },
          {
            data: [0, 0, 0, 0, 0],
            name: 'Internal Job Board',
          },
        ],
      },
      chartType: 'column',
    },
    api: {
      subject_type: 'contacts',
      metadata: {
        tileKey: 'contacts_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        defaultFilters: {
          group_by_2: 'contact_source',
        },
        id: 'contacts_chart',
      },
    },
  },

  // table
  {
    containerType: 'contacts',
    componentType: 'table',
    componentReference: 'table',
    id: 'contacts_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Candidate breakdown',
      id: 'contacts_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          contacts_created: 70,
          contacts_created_total: 8824,
          contacts_created_per: '0.8',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          contacts_created: 637,
          contacts_created_total: 8824,
          contacts_created_per: '7.2',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          contacts_created: 2650,
          contacts_created_total: 8824,
          contacts_created_per: '30.0',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          contacts_created: 4451,
          contacts_created_total: 8824,
          contacts_created_per: '50.4',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          contacts_created: 1016,
          contacts_created_total: 8824,
          contacts_created_per: '11.5',
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'contacts',
      metadata: {
        tileKey: 'contacts_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: null, label: 'Time' },
          group_by_2: { id: null, label: 'None' },
        },
        headerKeys: [
          'contacts_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'contacts_table',
      },
    },
  },
];

export const contactsLayoutConfig = [
  {
    key: 'contacts_new',
    x: 0,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'contacts_sourced',
    x: 3,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'contacts_inbound',
    x: 6,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'contacts_referral',
    x: 9,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'contacts_chart',
    x: 0,
    y: 7,
    w: 12,
    h: 22,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'contacts_table',
    x: 0,
    y: 29,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
